// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 延期券详情 GET /delay_coupon/info */
export async function delayCouponInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.delayCouponInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultDelayCouponInfoResp>('/delay_coupon/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
